export default class Gmap{
	constructor(params) {
		let options;
		const default_options = {
			target : 'map',
			styles : [{"stylers": [{ "visibility": "on" },{ "saturation": -100 },{ "lightness": 28 },{ "gamma": 0.98 }]}],
			center : {lat:35.010824 , lng:135.759710},
			pins : [{lat:35.010824 , lng:135.759710}],
			settings : {
				zoom:17,
				icon:'',
				title:'map',
			}
		};
		options = params || default_options;

		this.target = options.target;
		this.styles = options.styles;
		this.center = options.center;
		this.pins = options.pins;
		this.settings = options.settings;
	}

	exec(){
		const colorName = 'thisstyle';
		const settings = this.settings;
		const MAP = document.getElementById(this.target);
		const myOptions = {
			zoom: settings.zoom,
			center : new google.maps.LatLng(this.center.lat,this.center.lng),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			streetViewControl:false,
			mapTypeControl: false,
			zoomControl: true,
			zoomControlOptions: {
				style: google.maps.ZoomControlStyle.LARGE
			},
			scrollwheel: false
		};

		const map = new google.maps.Map(MAP, myOptions);

		//デザイン設定と地図タイプの名前を反映
		map.mapTypes.set(colorName, new google.maps.StyledMapType(this.styles, { name: colorName }));
		map.setMapTypeId(colorName);

		//marker
		let markers = [];
		_.each(this.pins,function(pin){
			let infoWindow;
			let marker = new google.maps.Marker();
			marker.setPosition(new google.maps.LatLng(pin.lat, pin.lng));
			marker.setIcon(settings.icon);
			marker.setTitle(settings.title);
			marker.setMap(map);
			markers.push(marker);

			infoWindow = new google.maps.InfoWindow({ // 吹き出しの追加
				content: `<a class="sample" target="_blank" href="${pin.link}">${pin.title}</a>`
			});
			google.maps.event.addListener(marker, 'click', function(event) {
				infoWindow.open(map, marker);
			});
		});

		this.set_default(map,markers);
	}

	set_default(map,markers){
		let activeMarker;
		if (markers.length == 1) {
			map.setCenter(markers[0].getPosition());
			map.setZoom(20);
		}
		if (markers.length > 1){
			let bounds = new google.maps.LatLngBounds();
			for (let i in markers) {
				if(activeMarker == markers[i]){
					activeMarker.setIcon(iconDefault);
					activeMarker = null;
				}

				// 緯度経度を取得
				if(Object.keys(markers[i]).length !== 0){
					let latlng = markers[i].getPosition();
					// 検索結果地が含まれるように範囲を拡大
					bounds.extend(latlng);
				}
			}
			map.fitBounds(bounds);
		}
	}
}
